import { useState } from "react";
import { useTranslation } from "react-i18next";

const LANGUAGE_STORAGE_KEY = "alsiyahiah.language";

export default function LanguageTranslatorButton({
  isTransparent = false,
  mobile = false,
}: {
  isTransparent?: boolean;
  mobile?: boolean;
}) {
  const { i18n, t } = useTranslation();
  const [isChanging, setIsChanging] = useState(false);
  const currentLanguage = i18n.language === "en" ? "en" : "ar";
  const nextLanguage = currentLanguage === "en" ? "ar" : "en";

  const handleClick = async () => {
    setIsChanging(true);
    window.localStorage.setItem(LANGUAGE_STORAGE_KEY, nextLanguage);
    await i18n.changeLanguage(nextLanguage);
    setIsChanging(false);
  };

  if (mobile) {
    return (
      <button
        type="button"
        onClick={handleClick}
        disabled={isChanging}
        className="flex items-center gap-2 px-4 py-3 rounded-xl text-sm font-medium text-gray-700 hover:bg-gray-50 transition-colors cursor-pointer disabled:opacity-60"
      >
        <i className="ri-translate-2 text-[#D4AF37]" />
        {nextLanguage === "en" ? t("translator.english") : t("translator.arabic")}
      </button>
    );
  }

  return (
    <button
      type="button"
      onClick={handleClick}
      disabled={isChanging}
      aria-label={
        nextLanguage === "en"
          ? t("translator.switchToEnglish")
          : t("translator.switchToArabic")
      }
      className={`h-9 px-3 flex items-center gap-1.5 rounded-full text-xs font-bold transition-colors cursor-pointer disabled:opacity-60 ${
        !isTransparent
          ? "text-gray-700 hover:bg-gray-100 border border-gray-100"
          : "text-white/90 hover:bg-white/15 border border-white/20"
      }`}
    >
      <i className="ri-translate-2 text-base" />
      <span>{nextLanguage === "en" ? "EN" : "AR"}</span>
    </button>
  );
}
